<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
// import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required, minValue } from "vuelidate/lib/validators";
// import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
// import Loader from "@/components/widgets/loader";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Vue from "vue";
// import Vuetable from "vuetable-2";
// import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { FulfillingBouncingCircleSpinner } from "epic-spinners";
// import MaskedInput from "vue-text-mask";
// import Switches from "vue-switches";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
// import vSelect from "vue-select";
// Vue.component("v-select", vSelect);
// register the plugin on vue
import Toasted from "vue-toasted";

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.
/**
 * new orden component
 */
export default {
  page: {
    title: "Nuevo Traslado",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    // PageHeader,
    // DatePicker,
    // Switches,
    // Vuetable,
    // VuetablePagination,
    // Loader,
    vSelect,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
    // "masked-input": MaskedInput,
  },
  data() {
    return {
      tiendasData: [],
      forSucursalE:{},
      forSucursalR:{},
      // variables metodos
      arrayBodegas:[],
      formEnvia : {
        id: null,
        bodega : "",
        tienda : null

      },
      formRecibe : {
        id: null,
        bodega : "",
        tienda : null

      },
      tienda : null,
      idCaja: 0,
      userT: this.$store.state.authfack.user,
      bandera: false,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      cantidad_efectivo: "",
      transferencia: [
        {
          cantidad_transferencia: "",
          transaccion_transferencia: "",
          button: true,
        },
      ],
      deposito: [
        {
          cantidad_deposito: "",
          transaccion_deposito: "",
          button: true,
        },
      ],
      cheque: [
        {
          cantidad_cheque: "",
          transaccion_cheque: "",
          button: true,
        },
      ],
      tarjeta: [
        {
          cantidad_tarjeta: "",
          transaccion_tarjeta: "",
          button: true,
        },
      ],
      checkMoney: {
        efectivo: false,
        transferencia: false,
        deposito: false,
        cheque: false,
        tarjeta: false,
      },
      checkSelect: {
        efectivo: false,
        transferencia: false,
        deposito: false,
        cheque: false,
        tarjeta: false,
      },
      montoFinal: {
        cantidad: 0,
        metodo: "",
        transaccion: "",
      },
      montos: {
        monto_efectivo: "",
        monto_transferencia: [],
        monto_deposito: [],
        monto_cheque: [],
        monto_tarjeta: [],
      },
      // variable credito
      formCredito: {
        color: false,
        asignado: false,
        fechaInicio: new Date(),
        intervalo: 7,
        collapse1: false,
        pagos: [],
        precioNuevo: 0,
        adelanto: "0",
        cantidadPagos: 0,
      },
      // variables nuevas
      porcentaje: "",
      indexPorcentaje: "",
      precioOriginal: "",
      precioDescuento: "",
      arrayProductos: [],
      producto: "",
      arrayServicios: [],
      servicio: "",
      busquedaLabel2: { nombre: "Código", value: "codigo" },
      busquedaLabel: { nombre: "Nombre", value: "producto" },
      busquedaTipos: [
        { nombre: "Nombre", value: "producto" },
        { nombre: "Código", value: "codigo" },
      ],
      busquedaTipos2: [{ nombre: "Código", value: "codigo" }],
      fieldsProductos: [
        { key: "action", label: "Acciones" },
        { key: "codigo", label: "Código" },
        { key: "producto", label: "Producto" },
        { key: "existencia", label: "Existencia" },
        { key: "departamento", label: "Ubicación" },
        { key: "precio_venta", label: "Precio venta" },
      ],
      fieldsServicios: [
        { key: "action", label: "Acciones" },
        { key: "nombre_servicio", label: "Servicio" },
        { key: "descripcion_servicio", label: "Descripción" },
      ],
      fechaVec: "",
      switchCliente: false,
      formCliente: {
        nombre: "",
        apellido: "",
        nit: "C/F",
        opciones: ["MASCULINO", "FEMENINO"],
        direccion: "",
        telefono: "",
        telefono_cliente: "",
        correo: "",
        cui: "",
        sexo: "",
        compania: "",
        direc: "",
        state: true,
        id: 0,
      },
      // variables para detalle
      ubicacionModel: 0,
      arrayEstante: [],
      estanteModel: 0,
      formget: {
        descripcion: "",
        pasillo: "",
        seccion: "",
        estante: "",
        departamentoId: "",
        id: 0,
      },
      activa_cliente: false,
      cabezera: [
        { key: "Opciones", label: "Opciones" },
        { key: "codigo", label: "Código" },
        { key: "producto", label: "Producto" },
        { key: "existencia", label: "Existencia" },
        { key: "cantidad", label: "Cantidad", thStyle: { width: "9%" } },

      ],
      cabezera2: [
        { key: "Opciones", label: "Opciones" },
        { key: "nombre_servicio", label: "Servicio" },
        { key: "descripcion_servicio", label: "Descripción" },
        { key: "cantidad", label: "Cantidad", thStyle: { width: "9%" } },
        {
          key: "precio_venta",
          label: "Precio Venta",
          thStyle: { width: "20%" },
        },
        { key: "subtotal", label: "Subtotal" },
      ],
      arrayCliente: [],
      arrayDepa: [],
      arrayClientes: [],
      apiUrl: process.env.VUE_APP_URL,
      apiBase:
        process.env.VUE_APP_URL +
        "productos/stock/busqueda?departamento=" +
        0 +
        "&estante=" +
        0,
      apiBase2: process.env.VUE_APP_URL + "servicios/select",
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      formPro: {
        fecha_compra: new Date(),
        tiendaid: "",
        observaciones: "",
        tienda: "",
        cliente: null,
        total: "",
        total_servicios: "",
        total_productos: "",
        state: true,
        id: 0,
      },
      data: [
        {
          nombre: "",
          cantidad: "",
          precio_compra: "",
          porcentaje_venta: "",
          precio_venta: "",
          subtotal: "",
          ubicacion: "",
          sub_presentacion: "",
          button: true,
        },
      ],
      title: "NUEVA VENTA",
      items: [
        {
          text: "Ventas",
          href: "/",
        },
        {
          text: "Nueva venta",
          active: true,
        },
      ],
      searchType: [
        { nombre: "Producto", value: "producto" },
        { nombre: "Codigo", value: "codigo" },
      ],
      searchType2: [{ nombre: "Nombre", value: "nombre" }],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      optionsFast: {
        theme: "outline",
        position: "top-right",
        duration: 2000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      loadingtable: false,
      sortBy: "nombre_producto",
      sortDesc: false,
      searchLabel: { nombre: "Producto", value: "producto" },
      filterLabel: { nombre: "Codigo", value: "codigo" },
      searchLabel2: { nombre: "Nombre", value: "nombre" },
      filterLabel2: { nombre: "Nombre", value: "nombre" },
      showModalL: false, //Loading
      showModalNP: false, //Nuevo cliente
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      pageOptions: [4, 10, 15, 20],
      search: "",
      search2: "",
      page: 1,
      perPage: 4,
      from: 0,
      to: 0,
      to2: 0,
      total: 0,
      total2: 0,
      lastPage: 0,
      lastPage2: 0,
      arrayDetalle: [],
      arrayDetalleServicio: [],
      idDepartamento: 0,
      traslado_masivo: false,
      arrayDet: [],
      idCliente: -1,
      isLoad: false,
      mask_porcentaje: createNumberMask({
        prefix: "",
        suffix: " %",
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ",",
        allowDecimal: true,
        decimalSymbol: ".",
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 10, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false,
      }),
      mask_quetzal: createNumberMask({
        prefix: "Q ",
        suffix: "",
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ",",
        allowDecimal: true,
        decimalSymbol: ".",
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 10, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false,
      }),
    };
  },
  validations: {
    formEnvia : {
        bodega : {required}
    },
    formRecibe : {
        bodega : {required}
    },
    forSucursalE : {
      tienda: {required}
    },
    forSucursalR : {
      tienda: {required}
    },
    arrayDetalle: {
      $each: {
        cantidad: {
          required,
          minValue: minValue(1),
        },
      },
    },
    data: { required },
    cantidad_efectivo: {
      required,
      // minValue: minValue(1),
    },
  },
  updated() {
    // this.$refs["inputCliente"].focus();
  },
  async mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
  
    this.getTiendas();
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
   

    
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    async validaSucursalEnvio(){
      let tienda = this.forSucursalE.tienda.id;
      await this.bodegasDisponibles(tienda);
    },
    async validaSucursalRecibe(){
      let tienda = this.forSucursalR.tienda.id;
      await this.bodegasDisponibles(tienda);
    },
    async bodegasDisponibles(tienda) {
      const response = await axios.get(
        process.env.VUE_APP_URL + "productos/bodegas_by_tienda?id=" + tienda,
        {
          headers: { "x-token": this.userT.token },
        }
      );
      this.arrayBodegas = response.data.bodegas;
      this.tienda = this.arrayBodegas[0].tienda;
    //   console.log(   this.formPro.tienda );
    },
    validaSelect(){
        // if(this.formEnvia!=''&&this.formRecibe!=''){
            // console.log('esta entrando', this.formEnvia, this.formRecibe);
            if(this.formEnvia.bodega.id== this.formRecibe.bodega.id){
            Vue.toasted.error("Debe seleccionar bodegas diferentes", this.options);
            this.formEnvia.bodega = '';
            this.formRecibe.bodega = '';
            this.arrayDetalle = [];
        }
        else if(this.formEnvia.bodega.id == undefined  && this.formRecibe.bodega !=''){
            Vue.toasted.error("Debe seleccionar la bodega que envia primero", this.options);

              this.formRecibe.bodega = '';
              this.arrayDetalle = [];
        }else{
            this.arrayDetalle = [];
        }
        // }
        
    },
   
    async focus(number) {
      if (number == 1) {
        
        setTimeout(() => {
          this.$refs["inputProductos"].focus();
        }, 300);
      }
      if (number == 2) {
        setTimeout(() => {
          this.$refs["inputServicios"].focus();
        }, 300);
      }
      if (number == 3) {
        setTimeout(() => {
          this.$refs["inputCredito1"].focus();
        }, 300);
      }
    },
 
   
    //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
    openModal(model) {
      switch (model) {
        case "save": {
          this.$v.formCliente.$reset();
          this.limpiarVariables();
          // console.log("entrando a resetear")
          break;
        }
        case "update": {
          this.$v.$reset();
          break;
        }
        case "productos": {
          this.arrayProductos = [];
          this.producto = "";
          // this.focus(1);
          break;
        }
        case "servicios": {
          this.arrayServicios = [];
          this.servicio = "";
          break;
        }
        case "porcentaje": {
          this.indexPorcentaje = 0;
          this.precioOriginal = "";
          this.precioDescuento = "";
          break;
        }
        case "credito": {
          if (this.formCredito.asignado == false) {
            // this.resetCredito();
          }
          break;
        }
      }
    },
    //Variables que necesitan ser limpiadas para los modales
    limpiarVariables() {
      // this.switchCliente = false;
      this.formCliente.id = 0;
      this.formCliente.telefono = "";
      this.formCliente.nombre = "";
      this.formCliente.nit = "C/F";
      this.formCliente.direccion = "";
    },
    limpiarTodo() {
      this.limpiarVariables();
    //   this.resetCredito();
      this.formPro;
      this.formPro = {
        fecha_compra: new Date(),
        tiendaid: "",
        observaciones: "",
        tienda: "",
        cliente: null,
        total: "",
        total_servicios: "",
        total_productos: "",
        state: true,
        id: 0,
      };
      this.gettienda();
      this.porcentaje = "";
      this.indexPorcentaje = "";
      this.precioOriginal = "";
      this.precioDescuento = "";
      this.arrayProductos = [];
      this.producto = "";
      this.arrayServicios = [];
      this.servicio = "";
      this.arrayDetalle = [];
      this.arrayDetalleServicio = [];
      this.search = "";
      this.search2 = "";
    },
    //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
    closeModal(model) {
      switch (model) {
        case "save": {
          this.showModalNP = false;
          this.showmodalL = false;
          break;
        }
        case "update": {
          this.showModalE = false;
          this.showmodalL = false;
          break;
        }
      }
    },
    //Para abrir los modales y pasar los datos de la fila o limpiar valores
    onActionClicked(action) {
      if (action == "new-item") {
        this.limpiarVariables();
      }
    },
    async gettienda() {
      let me = this;
      me.formPro.tiendaid = "";
      me.formPro.tienda = "";

      axios
        .get(process.env.VUE_APP_URL + "tiendas/selectById?id="+this.userT.tienda, {
          headers: { "x-token": this.userT.token },
        })
        .then(function (response) {
          console.log(response);
          me.formPro.tienda = response.data.data.nombre_tienda;
          me.formPro.tiendaid = response.data.data.id;
         
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
        });
    },
    tomandototal() {
      let temp = parseFloat(this.calcularTotal);
      let temp2 = parseFloat(this.calcularProductos);
      let temp3 = parseFloat(this.calcularServicios);
      this.formPro.total = temp;
      this.formPro.total_productos = temp2;
      this.formPro.total_servicios = temp3;
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    //Validaciones antes de guardar
    validaciones(opc) {
      // stop here if form is invalid
      // console.log(this.formPro.cliente);
      this.formPro.tienda = this.userT.tienda;
      console.log(this.formEnvia, this.formRecibe)
      this.$v.$touch();
      if (
        this.formEnvia.bodega == "" ||  this.formEnvia.bodega == "null" ||       this.formEnvia.bodega == null ||
        this.formPro.tienda == "" ||
        this.formRecibe.bodega == "" ||      this.formRecibe.bodega == "null" ||       this.formRecibe.bodega == null
      ) {
        Vue.toasted.error("Debe seleccionar bodega de envio y bodega que recibe", this.options);
      } else {
        if (
          this.arrayDetalle.length > 0 
        ) {
          if (this.$v.arrayDetalle.$error) {
            Vue.toasted.error("Complete los campos de productos", this.options);
          } else {
            this.showModalL = true;
            if (opc == "save") {
              // console.log("guarda");
              this.save();
            }
          }
        }

     

        if (
          this.arrayDetalleServicio.length == 0 &&
          this.arrayDetalle.length == 0
        ) {
          Vue.toasted.error("Debe agregar detalles", this.options);
        }
      }
    },
    swNit() {
      if (!this.toggleNit) {
        this.formCliente.nit = "C/F";
      }
      // else {
      //   this.formCliente.nit = "";
      // }
    },
    validacionesCliente(opc) {
      // stop here if form is invalid
      this.$v.formCliente.nombre.$touch();
      // this.$v.formCliente.telefono_cliente.$touch();
      // let telC = 0;
      let { nombre } = this.formCliente;

      // for (let i = 0; i < telefono_cliente.length; i++) {
      //   if (telefono_cliente[i] == "_" || telefono_cliente[i] == "") {
      //     telC++;
      //   }
      // }

      if (nombre != "") {
        this.showModalL = true;
        if (opc == "save") {
          // console.log("cliente", this.formCliente);
          this.saveCliente();
        }
        if (opc == "update") {
          this.update();
        }
      } else {
        Vue.toasted.error("Complete los datos del cliente", this.options);
      }
    },
    //Guardar registro
    save() {
      
        axios
          .post(
            process.env.VUE_APP_URL + "traslados/store",
            {
                recibe : this.formRecibe.bodega.id,
                envia :this.formEnvia.bodega.id,
                usuario: this.userT.id,
                tienda: this.userT.tienda,
                data: this.arrayDetalle,
            },
            {
              headers: { "x-token": this.userT.token },
            }
          )
          .then(() => {
            Vue.toasted.success("Traslado guardado", this.optionsFast);
            this.limpiarTodo();
            this.showModalL = false;
            this.$router.push({
              name: "traslados"
            });
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("Error!", error);
            Vue.toasted.error("Error para guardar", this.options);
          })
          .finally(() => {
            this.showModalL = false;
          });
    
    },
   
    // Funciones para trabajar con detalles
    eliminarDetalle({ index }) {
      let me = this;
      me.arrayDetalle.splice(index, 1);
    },
    eliminarDetalleServicio({ index }) {
      let me = this;
      me.arrayDetalleServicio.splice(index, 1);
    },
    converMaskToNumberxd(number) {
      var myNumber = "";
      for (var i = 0; i < number.length; i += 1) {
        if (
          number.charAt(i) === "Q" ||
          number.charAt(i) === "€" ||
          number.charAt(i) === "$" ||
          number.charAt(i) === "%" ||
          number.charAt(i) === "," ||
          number.charAt(i) === " "
        ) {
          continue;
        } else {
          myNumber += number.charAt(i);
        }
      }
      return parseFloat(myNumber).toFixed(2);
    },
 
    updateDisableDates({ index }) {
      const me = this;
      me.arrayDetalle[index].subtotal =
        (me.arrayDetalle[index].cantidad != ""
          ? me.arrayDetalle[index].cantidad
          : 0.0) *
        (me.arrayDetalle[index].precio_venta != ""
          ? me.arrayDetalle[index].precio_venta
          : 0.0);
      this.$refs.table.refresh();

      // item.no_extras = 0;
    },
   
    formatQuetzales(amount) {
      let num = parseFloat(amount),
        formatted;
      formatted = num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
      return (amount = "Q " + formatted);
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMM Do YYYY");
    },
  
   
    agregarDetalle(data) {
      const me = this;
      console.log(data)
     if(parseInt(data.existencia) <=0){
        Vue.toasted.error("Producto sin existencia en tienda");
        return;
     }
          me.arrayDetalle.push({
            id : data.producto.id,
            inventarioProductoId : data.id,
         
            codigo: data.producto.codigo_stock,
            departamento: data.bodega.nombre_bodega,
     
            producto: data.producto.nombre_producto,
            imagen_stock: data.producto.imagen_stock,
            cantidad: 1,
            existencia_actual: data.existencia,
         
          });
          this.producto = null;
        //   this.resetCredito();
   
      // console.log(me.arrayDetalle);
    },
 
    verificarstock(stock) {
      const me = this;
      // console.log(stock, 'estock');
      if (me.encuentra(stock.id)) {
        return true;
      }
    },
    cambiarCantidadPrecio(data) {
      if(parseInt(data.item.cantidad)>parseInt(data.item.existencia_actual)){
        // console.log('esta entrando');
        this.arrayDetalle[data.index].cantidad = parseInt(data.item.existencia_actual);
      }
      else if(parseInt(data.item.cantidad)<=0){
        this.arrayDetalle[data.index].cantidad = 1;
      }
  
      this.$refs.table.refresh();
    },
    verificarServicio(stock) {
      const me = this;
      // console.log(stock)
      if (me.encuentra2(stock["id"].toString())) {
        return true;
      }
    },
    // Esta función encuentra si en el detatalle ya esta la habitacion
    encuentra(id) {
      let sw = 0;
      for (var i = 0; i < this.arrayDetalle.length; i++) {
        if (this.arrayDetalle[i].id == id) {
          sw = true;
        }
      }
      return sw;
    },
    encuentra2(id) {
      let sw = 0;
      for (var i = 0; i < this.arrayDetalleServicio.length; i++) {
        if (this.arrayDetalleServicio[i].id.toString() == id) {
          sw = true;
        }
      }
      return sw;
    },
    async getProductos(producto) {
      this.arrayProductos = [];
      const tienda = this.userT.tienda;
      const bodega = this.formEnvia.bodega.id;
    //   console.log(bodega);
      if(bodega == "" || bodega == undefined || bodega == 'undefined'){
        Vue.toasted.error("Debe seleccionar la bodega de salida", this.options);
        return;
      }
      if (producto == "" || producto == " ") {
        this.arrayProductos = [];
        return;
      } else {
        try {
          const response = await axios.get(
            process.env.VUE_APP_URL +
              `productos/get/busqueda/bodega?criterio=${this.busquedaLabel.value}&search=${producto}&tienda=${tienda}&bodega=${bodega}`,
            {
              headers: { "x-token": this.userT.token },
            }
          );
          this.arrayProductos = response.data.data;
        //   console.log(this.arrayProductos);
        } catch (error) {
          console.log(error);
        }
      }
    },
    async getServicios(servicio) {
      this.arrayServicios = [];
      if (servicio == "" || servicio == " ") {
        return;
      } else {
        const response = await axios.get(
          process.env.VUE_APP_URL + `servicios/select?search=${servicio}`,
          {
            headers: { "x-token": this.userT.token },
          }
        );
        this.arrayServicios = response.data.data;
      }
    },
   

    //Buscador dentro de la tabala
    onFiltered() {
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
    onFiltered2() {
      this.search2 = this.search2.toLowerCase();
      this.$refs.vuetable2.refresh();
    },
    //enviar datos a la Paginacion
    onPaginationData(paginationData) {
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      // this.items = paginationData.data;
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onPaginationData2(paginationData) {
      this.to2 = paginationData.to;
      this.total2 = paginationData.total;
      this.lastPage2 = paginationData.last_page;
      // this.items = paginationData.data;
      this.$refs.pagination2.setPaginationData(paginationData);
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
      this.$refs.vuetable.refresh();
    },
    changePageSize2() {
      this.$refs.vuetable2.refresh();
    },

    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
      this.searchLabel = type;
      this.$refs.vuetable.refresh();
    },
    changeTypeSearch2(type) {
      this.searchLabel2 = type;
      this.$refs.vuetable2.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },

    onChangePage2(page) {
      this.$refs.vuetable2.changePage(page);
    },
    //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      return sortOrder[0]
        ? {
            criterio: sortOrder[0]
              ? sortOrder[0].sortField
              : this.searchLabel.value,

            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          }
        : {
            criterio: sortOrder[0]
              ? sortOrder[0].sortField
              : this.searchLabel.value,

            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          };
    },
    makeQueryParams2(sortOrder, currentPage) {
      return sortOrder[0]
        ? {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "nombre_persona",
            categoria: this.searchLabel2.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search2,
          }
        : {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "nombre_persona",
            categoria: this.searchLabel2.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search2,
          };
    },

    // Tiendas
    getTiendas(){
      let me = this;
      me.tiendasData = [];
      
      axios
        .get(process.env.VUE_APP_URL + "tiendas/busqueda",{
            headers: { "x-token": this.userT.token}
          })
        .then(function (response) {
          // console.log(response);
          me.tiendasData = response.data.data;
        })
        .catch(function (error) {
          console.log(error);
        })
  },
  },
};
</script>

<template>
  <Layout>
  
    <!-- Modal productos -->
    <b-modal
      centered
      @show="openModal('productos')"
      @hidden="openModal('productos')"
      id="modalProductos"
      ref="modalProductos"
      title="Productos"
      size="lg"
      title-class="text-black font-18"
      body-class="p-3"
    >
      <b-form-group>
        <b-input-group>
          <b-dropdown variant="secondary" size="sm">
            <template v-slot:button-content>
              {{ busquedaLabel.nombre }}
              <i class="mdi mdi-chevron-down"></i>
            </template>
            <b-dropdown-item
              v-for="(search, index) in busquedaTipos"
              :key="index"
              @click="cambiarTipo(search, 1)"
              >{{ search.nombre }}
            </b-dropdown-item>
          </b-dropdown>
          <b-input
            ref="inputProductos"
            v-model="producto"
            placeholder="Ingrese el código o nombre del producto"
            @input="getProductos(producto)"
          >
          </b-input>
        </b-input-group>
      </b-form-group>

      <b-table striped :items="arrayProductos" :fields="fieldsProductos">
        <template #cell(action)="data">
          <b-button
            v-if="verificarstock(data.item.producto) != true"
            @click="agregarDetalle(data.item)"
            variant="outline-primary"
            ><i class="bx bx-plus-medical"></i
          ></b-button>
        </template>
        <template #cell(producto)="data">
          <a
            :href="
              apiUrl + 'productos/get/imagen/' + data.item.producto.imagen_stock
            "
            target="_blank"
          >
            {{ data.item.producto.nombre_producto }}
          </a>
        </template>

        <template #cell(codigo)="data">
          {{ data.item.producto.codigo_stock }}
        </template>
        <template #cell(existencia)="data">
          {{ data.item.existencia }}
        </template>
        <template #cell(departamento)="data">
          {{ data.item.bodega.nombre_bodega }}
        </template>
        <template #cell(precio_venta)="data">
          {{ money(data.item.producto.precio_venta) }}
        </template>
      </b-table>

      <template #modal-footer="{}">
        <b-button variant="danger" @click="$bvModal.hide('modalProductos')"
          >Cerrar
        </b-button>
      </template>
    </b-modal>

    
   

    <b-modal
      centered
      v-model="showModalL"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
      no-close-on-backdrop
      content-class="my-class"
      header-class="my-class"
    >
      <template #modal-header="{}">
        <!-- Emulate built in modal header close button action -->

        <h5></h5>
      </template>
      <form>
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <fulfilling-bouncing-circle-spinner
                :animation-duration="2000"
                :size="90"
                color="#2a3042"
              />
            </div>
          </div>
        </div>
      </form>
    </b-modal>
    <!-- <PageHeader :title="title" :items="items" /> -->
    <!-- ESTA PARTE ES PARA LA CABECERA -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col">
                <h4>NUEVO TRASLADO {{ showDate(new Date()) }}</h4>
              </div>
              <div class="col" align="right">
              
              </div>
            </div>

            <div class="text-center">
              <div align="left">
          
                <div class="row">
                  <div class="col">
                    <div>
                        <p class="text-muted mb-2">Sucursal Envio</p>
                      <div >
                        <v-select v-model.trim="$v.forSucursalE.tienda.$model" :state="!$v.forSucursalE.tienda.$error" @input="validaSucursalEnvio" :options="tiendasData" label="nombre_tienda"
                            ></v-select>
                    
                        <div
                          :class="{
                            'invalid-feedback': true,
                            'd-block':
                              $v.forSucursalE.tienda.$error &&
                              !$v.forSucursalE.tienda.required,
                          }"
                        >
                          Debe seleccionar una sucursal de envío
                        </div>
                      </div>
                 </div>
                  </div>
                  <div class="col">
                    <div>
                        <p class="text-muted mb-2">Bodega envía</p>
                      <div >
                        <v-select v-model.trim="formEnvia.bodega"        @input="validaSelect" :options="arrayBodegas" label="nombre_bodega">
                    
                        </v-select>
                        <div
                          :class="{
                            'invalid-feedback': true,
                            'd-block':
                              $v.formEnvia.bodega.$error &&
                              !$v.formEnvia.bodega.required,
                          }"
                        >
                          Debe seleccionar una bodega de envío
                        </div>
                      </div>
                 </div>
                  </div>
                  <div class="col">
                    <div>
                        <p class="text-muted mb-2">Sucursal Recibe</p>
                      <div >
                        <v-select v-model.trim="$v.forSucursalR.tienda.$model" :state="!$v.forSucursalR.tienda.$error" @input="validaSucursalRecibe" :options="tiendasData" label="nombre_tienda"
                            ></v-select>
                        <div
                          :class="{
                            'invalid-feedback': true,
                            'd-block':
                              $v.forSucursalR.tienda.$error &&
                              !$v.forSucursalR.tienda.required,
                          }"
                        >
                          Debe seleccionar una sucursal que recibe
                        </div>
                      </div>
                 </div>
                  </div>
                  <div class="col">
                    <div>
                        <p class="text-muted mb-2">Bodega recibe</p>
                      <div >
                        <v-select v-model.trim="formRecibe.bodega"        @input="validaSelect" :options="arrayBodegas" label="nombre_bodega">
                        </v-select>
                        <div
                          :class="{
                            'invalid-feedback': true,
                            'd-block':
                              $v.formRecibe.bodega.$error &&
                              !$v.formRecibe.bodega.required,
                          }"
                        >
                          Debe seleccionar una bodega que recibe
                        </div>
                      </div>
                   </div>
                  </div>
                  <div class="col d-grid">
                    <b-button
                      block
                      size="md"
                      variant="primary"
                      @click="focus(1)"
                      v-b-modal.modalProductos
                    >
                      AGREGAR PRODUCTOS&nbsp;&nbsp;<i
                        class="bx bx-grid-alt"
                      ></i>
                    </b-button>
                  </div>
                  
                </div>
                <!-- <br /> -->

                <!-- <h5 v-if="arrayDetalle.length > 0" class="pt-3">
                  &nbsp;&nbsp;&nbsp;Productos
                </h5> -->
                <b-table
                  small
                  striped
                  v-if="arrayDetalle.length > 0"
                  ref="table"
                  :items="arrayDetalle"
                  :fields="cabezera"
                >
                  <!-- <template #cell(producto)="data">
                      <a
                        :href="
                          apiUrl +
                          'productos/get/imagen/' +
                          data.item.imagen_stock
                        "
                        target="_blank"
                      >
                        {{ data.item.producto }}
                      </a>
                    </template> -->
                  <template #cell(codigo)="data">
                    {{ data.item.codigo }}
                  </template>
                  <template #cell(opciones)="data">
                    <b-button-group>
                      <b-button
                        class="icon-content col-xl-8 col-lg-4 col-sm-"
                        size="md"
                        variant="outline-danger"
                        @click="eliminarDetalle(data)"
                        ><i :class="'bx bx-undo'" />
                      </b-button>
                  
                    </b-button-group>
                  </template>
               
                  <template #cell(cantidad)="data">
                    <b-form-input
                      @keyup="cambiarCantidadPrecio(data)"
                      @input="cambiarCantidadPrecio(data)"
                      v-model="data.item.cantidad"
                      placeholder="Ingrese la cantidad"
                      type= "number"
                    ></b-form-input>
                  </template>
                  <template #cell(existencia)="data">
                    {{ data.item.existencia_actual }}
                  </template>
                </b-table>


              </div>

              <!-- Botones -->
              <div class="col-sm-12 pt-3">
                <div class="row">
                  <div class="col">
                    <router-link
                      class="d-grid gap-2"
                      :to="{
                        name: 'traslados',
                      }"
                    >
                      <b-button
                        block
                        size="lg"
                        variant="outline-primary"
                        type="button"
                        class="btn btn-rounded mb-2 me-2"
                      >
                        <i class="bx bx-arrow-back"></i>&nbsp;&nbsp;<b
                          >REGRESAR</b
                        >
                      </b-button>
                    </router-link>
                  </div>
                  <div class="col d-grid gap-2">
                    <b-button
                      block
                      size="lg"
                      variant="outline-success"
                      class="btn btn-rounded mb-2 me-2"
                      @click="validaciones('save')"
                    >
                    <i class="mdi mdi-truck-fast me-1"></i>
                      &nbsp;&nbsp;<b>GUARDAR</b>
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end card -->
    </div>
    <!-- end col -->
  </Layout>
</template>
